<template>
  <div>
    <div class="row">
      <div class="col-7">
        <b-form-datepicker v-model="stockDiff.date" locale="id" size="sm" :max="new Date()" />
      </div>

      <div class="col-5">
        <b-form-timepicker v-model="stockDiff.time" locale="id" size="sm"/>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-7">
        <input
          class="form-control"
          :value="item ? item.LogisticItem.Name : ''"
          readonly />
      </div>

      <div class="col-2">
        <v-select
          v-model="stockDiff.condition"
          :options="['Kurang', 'Lebih']"/>
      </div>

      <div class="col-3">
        <div class="input-group">

          <input
            type="number"
            min="1"
            class="form-control"
            v-model.number="stockDiff.quantity"
            @keypress="$helper.inputRestrictNumber($event, formDistribute.Quantity, maxItem)"
            placeholder="Jumlah"/>

          <div class="input-group-prepend">
            <div class="input-group-text">
              {{ item ? item.LogisticItem.LogisticItemUnit.DistributionUnit : '' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-form-textarea
      v-model="stockDiff.reason"
      rows="2"
      placeholder="Alasan terjadinya selisih barang"
      max-rows="6" />

    <div class="text-center my-2">
      <button class="btn btn-primary btn-sm" @click="diplayStockDiff">Lanjutkan</button>
    </div>

    <iframe ref="stockDiffFrame" id="stockDiffFrame" class="w-100" height="600" name="stockDiffFrame"></iframe>

    <div class="text-center">
      <button class="btn btn-primary" @click="printStockDiff">Print</button>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  mounted() {
    this.fetchOptionData()
  },
  data() {
    return {
      deputyDirectorGeneral: null, //wadir umum
      headOfGeneral: null, //kabag umum
      stockDiff: {
        condition: 'Kurang',
        quantity: null,
        reason: '',
        date: (new Date()).toISOString().slice(0,10),
        time: (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':00'
      }
    }
  },
  computed: {
    employeeProfile () {
      return this.$store.state.user.userData.employee
    }
  },
  methods: {
    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/employee?positionId=118'), //wadir umum
        this.$axios.get('/employee?positionId=121&departmentId=2') //kabag umum
      ]).then(this.$axios.spread((...res) => {
        this.deputyDirectorGeneral = res[0].data[0]
        this.headOfGeneral = res[0].data[0]
      }))
    },
    diplayStockDiff () {
      const content = `
        <h2 class="text-center">BERITA ACARA</h2>
        <h2 class="text-center">SELISIH BARANG</h2>
        <br />

        <p style="text-indent: 50px; text-align: justify;">
          Pada hari ${this.$helper.getDayName(this.stockDiff.date)}, tepatnya tanggal ${this.$helper.formatDate(this.stockDiff.date)} pukul ${this.stockDiff.time} WIB, Saya ${this.employeeProfile.Name} sebagai pengurus barang telah menemukan selish barang. Selanjutnya membuat sebuah berita acara selisih barang sebagaimana berikut ini:
        </p>

        <table border="1">
        <tr>
          <th rowspan="2">Nama Barang</th>
          <th colspan="2">Selisih</th>
          <th rowspan="2">Jumlah</th>
        </tr>

        <tr>
          <th>Qty</th>
          <th>Harga</th>
        </tr>

        <tr>
          <td>${this.item.LogisticItem.Name}</td>
          <td>${this.stockDiff.quantity}</td>
          <td>Rp. .........</td>
          <td>Rp. .........</td>
        </tr>
        </table>

        <p>
          Alasan : <br>
          ${this.stockDiff.reason}
        </p>


        <br>

        <div class="box" style="float: left;">
          <h4>Kepala Bagian Umum</h4>
          <br><br><br>

          <h4>${this.headOfGeneral.Name}</h4>
          <h4>NIP. ${this.headOfGeneral.EmployeeIdNumber ? this.headOfGeneral.EmployeeIdNumber : '-'}</h4>
        </div>

        <div class="box" style="float: right;">
          <h4>Pengurus Barang</h4>
          <br><br><br>

          <h4>${this.employeeProfile.Name}</h4>
          <h4>NIP. ${this.employeeProfile.EmployeeIdNumber ? this.employeeProfile.EmployeeIdNumber : '-'}</h4>
        </div>

        <div style="clear: both;"></div>
        <br>
        <br>
        <div class="text-center">
          <h4>MENGETAHUI / MENYETUJUI</h4>
          <h4>WADIR UMUM & KEUANGAN</h4>
          <br><br><br>

          <h4>${this.deputyDirectorGeneral.Name}</h4>
          <h4>NIP. ${this.deputyDirectorGeneral.EmployeeIdNumber ? this.deputyDirectorGeneral.EmployeeIdNumber : '-'}</h4>
        </div>
      `

      this.$nextTick(function () {
        const html = this.$constant.TEMPLATE_PRINT_HEADER + content + this.$constant.TEMPLATE_PRINT_FOOTER

        this.$refs.stockDiffFrame.srcdoc = html
      })
    },

    printStockDiff () {
      // window.frames['stockDiffFrame'].focus()
      window.frames['stockDiffFrame'].print()
    }
  }
}
</script>

<style scoped>
</style>